import "./_inputLabel.scss";

import cx from "classnames";
import {InputHTMLAttributes, ReactElement} from "react";
import React, {forwardRef} from "react";

type InputLabelProps = {
  id: string;
  label?: string;
  complementLabel?: string;
  complementLibelle?: string;
} & InputHTMLAttributes<HTMLInputElement>;

const InputLabel = forwardRef<HTMLInputElement, InputLabelProps>(
  (
    {
      id,
      label = "",
      complementLabel = "",
      complementLibelle = "",
      defaultValue = "",
      type = "text",
      name,
      disabled = false,
      onChange,
      min = 0,
      max = 9999999999999,
      step = 1,
      ...props
    },
    ref,
  ): ReactElement => {
    const handleWheel = (event: React.WheelEvent<HTMLInputElement>): void => {
      (event.target as HTMLInputElement).blur();
    };
    return (
      <div className="inputCustom">
        <label htmlFor={id} className={cx(disabled ? "disabled" : "")}>
          {label} <span>{complementLibelle}</span>
          <br />
        </label>
        <input
          id={id}
          type={type}
          name={name}
          min={min}
          max={max}
          step={step}
          defaultValue={defaultValue}
          onChange={onChange}
          disabled={disabled}
          onWheel={handleWheel}
          ref={ref}
          {...props}
        />
        <p className="inputCustom-complementLabel">
          <span>{complementLabel}</span>
        </p>
      </div>
    );
  },
);

export default InputLabel;
